import type { SVGProps } from 'react';

const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17.31 15.89a8 8 0 0 0 1.69-4.9C19 6.59 15.41 3 11 3s-8 3.59-8 8 3.59 8 8 8c1.85 0 3.54-.63 4.9-1.69l3.4 3.4c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM11 17c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6"
    />
    <path
      fill="currentcolor"
      d="M11 7c-2.21 0-4 1.79-4 4 0 .55.45 1 1 1s1-.45 1-1c0-1.1.9-2 2-2 .55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgSearch;
